
// const webrtcplayer = require("./js/webRtcPlayer");
// const app = require("./js/app");

export class psserver {

    private url = 'https://webcadv15-ue-dev.marietta.co.jp/matchmaker';
    private dev_url = 'https://webcadv15-ue-dev.marietta.co.jp/matchmaker-dev';

    constructor(url_?: string) {
        if (url_) {
            this.url = url_;
        }
    }

    public get(): Promise<string | void> {
        console.log(`URL: ${this.url}\n`);
        console.log(`\tGET Method`);

        const controller = new AbortController();
        const timeout = setTimeout(() => { controller.abort() }, 10000);

        if (location.href.indexOf('localhost') > -1) {
            this.url = this.dev_url;
        }
        if (location.href.indexOf('https://webcad15.marietta.stg') > -1 || location.href.indexOf('https://webcad15.marietta.dev') > -1) {
            this.url = this.dev_url;
        }

        return fetch(this.url, { method: 'GET',
                                 mode: 'cors',
                                 cache: "no-store",
                                 signal: controller.signal })
            .then((response) => {
                if (response.ok) {
                    return response.text();
                }
                if (response.status == 404) {
                    return response.text();
                }
                if (!response.ok) {
                    const object = response.json();
                    console.error('response.ok:', response.ok);
                    console.error('esponse.status:', response.status);
                    console.error('esponse.statusText:', response.statusText);
                    throw new Error(response.statusText);
                  }
                return Promise.reject(new Error(`${response.status}: ${response.statusText}`));
            })
            .catch((error) => {
                return Promise.reject(new Error(error));
            });
    }
}
